module.exports = __webpack_public_path__ + "static/media/entry_insurance_advisory.1f5bd802.svg";